import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconCrossCircle = ({
  color = colors.grey1,
  className,
  style,
  size = 12,
}: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...style}
  >
    <path
      d="M7.67139 7.84241L4.32908 4.5001"
      stroke={color}
      strokeWidth="0.9"
      strokeLinecap="round"
    />
    <path
      d="M4.32861 7.84232L7.67092 4.50001"
      stroke={color}
      strokeWidth="0.9"
      strokeLinecap="round"
    />
    <path
      d="M9.18197 2.81802C10.9393 4.57538 10.9393 7.42462 9.18197 9.18197C7.42461 10.9393 4.57537 10.9393 2.81802 9.18197C1.06066 7.42461 1.06066 4.57537 2.81802 2.81802C4.57538 1.06066 7.42462 1.06066 9.18197 2.81802"
      stroke={color}
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconCrossCircle;
